
import { CommodityDetail } from "features/contracts/enums/commodityDetail";
import { ContractStatus } from "features/contracts/enums/contractStatus";
import { InvoiceState } from "features/invoices/enums/invoiceState";
import { InvoiceType } from "features/invoices/enums/invoiceType";
import { MessageStatus } from "features/messages/enums/messageStatus";
import { CustomerRole } from "features/customer/enums/customerRole";
import { ContractType } from "features/contracts/enums/contractType";
import { ContractualAccountStatus } from "features/contractualAccounts/enums/contractualAccountStatus";
import { ContractCategoryRate } from "features/contracts/enums/contractCategoryRate";
import { PlaceOfDeliveryType } from "features/placeOfDelivery/enums/placeOfDeliveryType";
import { BoolEnum } from "features/shared/enums/boolEnum";
import { MessageCategory } from "features/messages/enums/messageCategory";
import { ContractingState } from "features/contracting/enums/contractingState";

// TODO: pouzit obecnou EnumsMap

export default class DataFilterEnumMap {
    CommodityDetail = CommodityDetail;
    ContractStatus = ContractStatus;
    InvoiceTypes = InvoiceType;
    InvoiceStates = InvoiceState;
    MessageStates = MessageStatus;
    Role = CustomerRole;
    ContractType = ContractType;
    ContractualAccountStatus = ContractualAccountStatus;
    ContractCategoryRate = ContractCategoryRate;
    PlaceOfDeliveryType = PlaceOfDeliveryType;
    IsProduction = BoolEnum;
    MessageCategories = MessageCategory;
    ContractingState = ContractingState;
}